import axios from 'axios'

const CLOUD_FUNCTIONS_URL =
  process.env.VUE_APP_CLOUD_FUNCTIONS_URL || 'https://thelifeboard.app'

const apiClient = axios.create({
  baseURL: `${CLOUD_FUNCTIONS_URL}/.netlify/functions`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  /**
   *
   * @param {*} payload contains property recaptchaToken
   */
  validateCaptcha(payload) {
    return apiClient.post('/verifyRecaptcha', payload)
  },

  /**
   *
   * @param {*} payload contains
   * name: string
   * email: string
   * tags: string[]
   */
  subscribeUser(payload) {
    return apiClient.post('/subscribe', payload)
  },
}
